import styled from "@emotion/styled";
export const Container = styled.div`
  display: relative;
  visibility: ${({ open }) => open && "visible"} !important;
`;
